import React from 'react';

const ANNOUNCEMENT_TEXT =
  '⚠️ IMPORTANT NOTICE: Our ABIDS GMB – Central Book Shop Retail account has been compromised. Please do not place orders, make payments, or respond to requests through the GMB account until further notice. Kindly use only our official website and verified communication channels for all orders and enquiries. Do not make any payments until further notice.';

const AnnouncementTicker = () => {
  return (
    <div className="it-announcement-ticker">
      <div
        className="it-announcement-ticker__track"
        role="status"
        aria-label={ANNOUNCEMENT_TEXT}
      >
        <span className="it-announcement-ticker__item" aria-hidden="true">
          {ANNOUNCEMENT_TEXT}
        </span>
        <span className="it-announcement-ticker__item" aria-hidden="true">
          {ANNOUNCEMENT_TEXT}
        </span>
      </div>
    </div>
  );
};

export default AnnouncementTicker;